import { map } from 'lodash/fp';
import { WebsocketEventType } from '@mews-commander/legacy-data-structures';
import { fetchReservations } from './actions';

export const reservationUpdatesHandler = {
    type: WebsocketEventType.ReservationUpdate,
    handle: (dispatch: $TSFixMe, getState: $TSFixMe, events: $TSFixMe) => {
        dispatch(fetchReservations(map('entityId', events)));
    },
};
